import {find} from 'lodash';
import set from 'lodash/set';
import React, {
  CSSProperties,
  FunctionComponent,
  useEffect,
  useState,
} from 'react';
import {useDispatch} from 'react-redux';
import swal from 'sweetalert2';
import {NotificationEditor} from '../../components/NotificationEditor';
import {getEndpoint, getHeaders} from '../../helpers/endpoint';
import {getParameterByName} from '../../helpers/location';
import {INotificationGet, NotificationTargeting} from '../../types/notifications';
import {getAllBlogPosts} from '../NotificationsList';

const styles: Record<string, CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    margin: 16,
  },
  titleContainer: {
    display: 'flex',
    height: 43,
    backgroundColor: 'white',
    width: '100%',
    alignItems: 'center',
    fontSize: 18,
    paddingLeft: 16,
  },
  flex1: {
    flex: 1,
  },
  flex2: {
    flex: 2,
  },
  saveButton: {
    height: 48,
    width: 150,
    color: '#4054CC',
    borderRadius: 4,
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: '#4054CC',
    fontWeight: 'bold',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 32,
  },
  disabledButton: {
    height: 48,
    width: 150,
    color: 'white',
    borderRadius: 4,
    backgroundColor: '#959DAF',
    fontWeight: 'bold',
    borderWidth: 0,
  },
};

export const calculateBlogPostTargeting = (
  payload: NotificationTargeting,
  onSuccess?: (response: {
    recentlyConnectedCount: number;
    totalCount: number;
  }) => void,
) => {
  return (_dispatch, getState) => {
    return fetch(getEndpoint('calculateBlogPostTargeting'), {
      method: 'POST',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${data.message}<br/>`,
          });
        } else {
          // eslint-disable-next-line no-unused-expressions
          onSuccess?.(data);
        }
      })
      .catch(error => {});
  };
};

export const createBlogPost = (
  payload: INotificationGet,
  onSuccess: (response: INotificationGet) => void,
) => {
  return (_dispatch, getState) => {
    return fetch(getEndpoint('createBlogPost'), {
      method: 'POST',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({
        ...payload,
        createdAt: undefined,
        id: undefined,
        status: undefined,
        type: undefined,
        updatedAt: undefined,
        cloudTaskId: undefined,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${data.message}<br/>`,
          });
        } else {
          onSuccess(data);
        }
      })
      .catch(error => {});
  };
};

export const CreateNotification: FunctionComponent = ({history}) => {
  const dispatch = useDispatch();
  const [notification, setNotification] = useState<INotificationGet>({});
  const onChange = (key: string, value: string | number | undefined) => {
    setNotification({
      ...set(notification, key, value !== '' ? value : undefined),
    });
  };

  useEffect(() => {
    if (getParameterByName('blogPostId', window.location.href)) {
      dispatch(
        getAllBlogPosts(response =>
          setNotification(
            // @ts-ignore
            find(response, {
              id: getParameterByName('blogPostId', window.location.href),
            }) || {},
          ),
        ),
      );
    }
  }, []);

  const onSubmit = () => {
    const onSuccess = (response: INotificationGet) => {
      history.push(`/notifications/update/${response.id}`);
    };
    if (notification.name) {
      dispatch(createBlogPost(notification, onSuccess));
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.flex2}>
        <div style={styles.titleContainer}>Create notification</div>
        <NotificationEditor
          onChange={onChange}
          data={notification}
          isCreation
          calculateBlogPostTargeting={calculateBlogPostTargeting}
        />
        <div style={styles.buttonContainer}>
          <button
            disabled={!notification.name}
            style={
              notification.name ? styles.saveButton : styles.disabledButton
            }
            onClick={onSubmit}>
            Sauvegarder
          </button>
          <span style={{marginLeft: 8, color: 'red'}}>*</span>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/CreateNotification/index.tsx